var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "select2Tags", class: { single: !_vm.multiple } },
    [
      _c(
        "label",
        {
          staticClass: "color-bo-grey2 text-regular mb-0",
          class: _vm.typeTag,
          style: {
            xtop: "-30px",
            "z-index": _vm.myTags ? 0 : 1,
            "padding-top": "5px",
          },
          attrs: { for: "" },
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _vm._v(" "),
      _c("Select2", {
        attrs: {
          options: _vm.optionList,
          settings: {
            multiple: this.multiple,
            dropdownCssClass: "tagsEditPanel-dropdown",
            allowClear: true,
            tags: this.editable,
          },
        },
        on: {
          open: function ($event) {
            return _vm.openEvent()
          },
          close: function ($event) {
            return _vm.closeEvent()
          },
        },
        model: {
          value: _vm.myTags,
          callback: function ($$v) {
            _vm.myTags = $$v
          },
          expression: "myTags",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }